// extracted by mini-css-extract-plugin
export default {"title":"_3x-Nbqgu60","tall":"pBFKf9NmCy"};